import React, { useState } from "react";
import "./App.css";
import Main from "./containers/Main";
import { ThemeProvider } from "styled-components";
import { light, dark } from "./theme";
import { GlobalStyles } from "./global";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import aud from "./assests/cricket.wav";
import aud2 from "./assests/baor.wav";

function App() {
	const [theme, setTheme] = useState(light);
	const [nightUrl] = useState(aud);
	const [dayUrl] = useState(aud2);
	const audio1 = new Audio(nightUrl);
	const audio2 = new Audio(dayUrl);
	const themeToggler = () => {
		theme === light ? setTheme(dark) : setTheme(light);
		theme === light ? audio1.play() : audio2.play();
	}
	return (

		<ThemeProvider theme={theme}>
			<>
				<GlobalStyles />
				<div>
					<div id="con" className="con">
						<OverlayTrigger
							placement={"bottom"}
							overlay={
								<Tooltip className="lgdark">
									{theme === light ? 'Switch To Dark' : 'Switch To Light'}
								</Tooltip>
							}
						>
							<div onClick={themeToggler} className="themeicon" aria-hidden="true"> {theme === light ? '🌛' : '☀️'}  </div>
						</OverlayTrigger>
					</div>
					<Main theme={theme} />
				</div>
			</>
		</ThemeProvider>
	);
}

export default App;
